export const brand = {
  name: 'Kit d’Animation Octobre Rose 3-en-1',
  short: 'KIT D’ANIMATION OCTOBRE ROSE',
  tag: 'Une solution clé en main pour vos actions Octobre Rose',
}

export const checkoutUrl = 'https://octobrerose.impultienda.ar'

export const mockups = {
  kit: 'https://cdn.magicpatterns.com/uploads/gWtuZSLhPBPT8CVebLX62p/mockup-fr.png',
  cards: 'https://cdn.magicpatterns.com/uploads/w4SvsbKpAAx7oehW3kVDkg/image.png',
  guide: 'https://cdn.magicpatterns.com/uploads/8rEobgFszNErNxNQopoB6G/prod3.png',
  bookmarks: 'https://cdn.magicpatterns.com/uploads/2tZHSDJxkpHfKuCZKynsBD/prod2.png',
}

/* Ce que contient le kit (première ligne sous le hero) */
export const heroContents: string[] = ['50 cartes', '150 marque-pages', 'Guide 50 pages', '3 bonus']

/* Badges pratiques (seconde ligne sous le hero) */
export const heroFacts: string[] = ['Accès immédiat', 'Prêt à imprimer', 'Kit 3-en-1', 'Accès à vie']

/* ---------- PRIX (modifiez uniquement ici) ---------- */
export const offer = {
  listPrice: '39\u00A0€',
  price: '19',
  currency: '€',
  /* Valeurs transmises au pixel Meta lors du clic sur le CTA */
  pixelValue: 19,
  currencyCode: 'EUR',
  subtitle: 'Offre de lancement · Accès à vie',
  detail:
    'Le kit complet (valeur 39\u00A0€) : 50 cartes de réflexion, 150 marque-pages inspirants et un guide d’animation de 50 pages, avec 3 bonus inclus (valeur 39\u00A0€) et un support par e-mail. Valeur totale : 78\u00A0€. Aujourd’hui, seulement 19\u00A0€.',
  cta: 'Je veux mon Kit Octobre Rose',
}

export const bonusTotal = '39\u00A0€'

export interface UseCase {
  icon: 'association' | 'hr' | 'training'
  role: string
  city: string
  description: string
}

export const useCases: UseCase[] = [
  {
    icon: 'association',
    role: 'Animatrice associative',
    city: 'Lyon',
    description:
      'Un atelier de 60 minutes à préparer ? Le déroulé, les cartes et les supports permettent de préparer rapidement une animation claire, sans repartir de zéro.',
  },
  {
    icon: 'hr',
    role: 'Responsable RH',
    city: 'Bordeaux',
    description:
      'Pour une action Octobre Rose en entreprise, les cartes facilitent un échange participatif, tandis que les marque-pages permettent à chacun de repartir avec un message à conserver.',
  },
  {
    icon: 'training',
    role: 'Formatrice',
    city: 'Nantes',
    description:
      '30, 60 ou 90 minutes : il suffit de choisir le format adapté, puis d’ajuster les activités selon le temps disponible et les besoins du groupe.',
  },
]

export interface ProductImage {
  src: string
  alt: string
}

export interface Product {
  eyebrow: string
  title: string
  lead: string
  body: string
  points?: string[]
  kicker: string
  images: ProductImage[]
}

export const products: Product[] = [
  {
    eyebrow: 'Produit 1',
    title: '50 Cartes de Réflexion',
    lead: '50 cartes prêtes à imprimer, conçues pour susciter la réflexion, ouvrir le dialogue et faciliter les échanges.',
    body: 'Utilisez-les pour introduire une activité, accompagner un atelier ou offrir un temps de pause et d’introspection, que ce soit en association, en entreprise, en établissement ou au sein d’un groupe. Elles sont fournies en PDF haute qualité, prêtes à imprimer.',
    kicker: 'Des questions simples qui ouvrent de vraies conversations.',
    images: [
      {
        src: mockups.cards,
        alt: 'Tablette affichant le PDF des Cartes de Réflexion Octobre Rose : neuf cartes avec des questions pour ouvrir le dialogue',
      },
    ],
  },
  {
    eyebrow: 'Produit 2',
    title: '150 Marque-pages Inspirants',
    lead: '150 marque-pages différents, prêts à imprimer et à découper, pour que le message accompagne chaque participante après l’événement.',
    body: 'Bienveillance envers soi, prévention, solidarité, soutien, bien-être : distribuez-les en fin d’animation, déposez-les sur les tables, intégrez-les à une activité ou laissez-les dans un espace de sensibilisation. Un joli souvenir d’Octobre Rose.',
    kicker: 'Un petit support à emporter. Un message qui reste.',
    images: [
      {
        src: mockups.bookmarks,
        alt: 'Main tenant trois marque-pages Octobre Rose illustrés d’un ruban rose, de fleurs et d’une femme au bouquet, avec des messages de bienveillance',
      },
    ],
  },
  {
    eyebrow: 'Produit 3',
    title: 'Guide d’Animation Octobre Rose — 50 pages',
    lead: 'Un guide pratique pour organiser et animer votre action Octobre Rose sans devoir tout créer vous-même.',
    body: '',
    points: [
      'Activités et idées d’animation prêtes à l’emploi',
      'Formats de 30, 45, 60, 90 et 120 minutes',
      'Utilisation des cartes de réflexion et des marque-pages',
      'Activités en binômes, cercles de parole, petits et grands groupes',
      'Scripts d’ouverture et de clôture',
      'Préparation de l’espace, checklists et gestion du temps',
      'Conseils pour faciliter les échanges et s’adapter au groupe',
      'Repères si un moment d’émotion survient',
      'Fiches pratiques à imprimer et conducteur minute par minute',
    ],
    kicker: 'Tout est structuré. Il ne reste plus qu’à animer.',
    images: [
      {
        src: mockups.guide,
        alt: 'Guide d’Animation Octobre Rose de 50 pages : couverture, fiche terrain, formats d’atelier de 30, 60 et 90 minutes et conducteur minute par minute',
      },
    ],
  },
]

export const deliverables: string[] = [
  '50 Cartes de Réflexion prêtes à imprimer',
  '150 Marque-pages Inspirants prêts à imprimer et à découper',
  'Guide d’Animation Octobre Rose de 50 pages',
  'Activités et dynamiques prêtes à l’emploi',
  'Formats d’animation de 30 à 120 minutes',
  'Scripts d’ouverture et de clôture',
  'Checklists de préparation',
  'Fiches pratiques imprimables',
  'Fichiers PDF haute qualité',
  'Accès immédiat après achat',
  'Accès à vie',
  'Support par e-mail',
]

export const deliverablesExtra = '+ 3 bonus inclus'

export interface Bonus {
  tag: string
  title: string
  subtitle: string
  lead: string
  promise: string
  includes: string[]
  value: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bonus 1',
    title: 'Guide de Soutien Émotionnel',
    subtitle: 'Trouver les mots justes lorsque l’émotion s’invite',
    lead: 'Un guide pratique pour réagir avec bienveillance lorsqu’une participante est émue ou partage une expérience personnelle difficile.',
    promise: 'Des repères concrets pour animer avec plus de sérénité.',
    includes: [
      'Les principes essentiels',
      'Des formulations simples et respectueuses',
      'Ce qu’il vaut mieux éviter de dire',
      'Écouter sans envahir',
      'Quand proposer une pause',
      'Quand orienter vers un professionnel compétent',
    ],
    value: '15\u00A0€',
  },
  {
    tag: 'Bonus 2',
    title: 'Octobre Rose : Mythes & Réalités',
    subtitle: 'Sensibiliser avec des informations claires et responsables',
    lead: 'Une ressource pratique pour aborder Octobre Rose de manière accessible, sans dramatiser ni relayer d’informations approximatives. Les contenus restent généraux et ne remplacent ni les recommandations officielles ni l’avis d’un professionnel de santé.',
    promise: 'Pour parler de prévention avec plus de clarté.',
    includes: [
      'Comprendre la démarche Octobre Rose',
      'Mythes et réalités',
      'Communiquer sans faire peur',
      'Questions fréquentes',
      'Bonnes pratiques de sensibilisation',
      'Un langage clair et respectueux',
    ],
    value: '12\u00A0€',
  },
  {
    tag: 'Bonus 3',
    title: 'Planificateur Express — Votre Action Octobre Rose en 48 h',
    subtitle: 'Passez de l’idée à une animation prête à accueillir votre public',
    lead: 'Une feuille de route simple pour organiser votre action Octobre Rose lorsque le temps manque.',
    promise: 'Une feuille de route claire pour préparer votre action sans vous éparpiller.',
    includes: [
      'Méthode en 4 étapes',
      'Planning sur 48 heures',
      'Formats 30 / 60 / 90 minutes',
      'Checklist du matériel',
      'Préparation de la salle',
      'Ouverture, déroulé et clôture',
      'Adaptations selon le contexte',
    ],
    value: '12\u00A0€',
  },
]

export const trustItems = [
  { icon: 'lock', label: 'Paiement sécurisé' },
  { icon: 'check', label: 'Accès immédiat' },
  { icon: 'money', label: 'Garantie 7 jours' },
  { icon: 'mail', label: 'Support par e-mail' },
] as const

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'Comment vais-je recevoir les fichiers ?',
    answer:
      'Après confirmation du paiement, vous recevrez les fichiers numériques par e-mail. Vous pourrez les télécharger et les conserver sur votre ordinateur, votre tablette ou votre téléphone.',
  },
  {
    question: 'Les fichiers sont-ils prêts à imprimer ?',
    answer:
      'Oui. Les ressources sont fournies en format numérique haute qualité et ont été conçues pour pouvoir être imprimées facilement.',
  },
  {
    question: 'Puis-je utiliser le kit pour plusieurs animations ?',
    answer:
      'Oui, vous pouvez réutiliser vos supports numériques pour préparer vos différentes actions, dans le respect des conditions d’utilisation du produit.',
  },
  {
    question: 'Faut-il être psychologue ou professionnel de santé pour utiliser le kit ?',
    answer:
      'Non. Le guide a été pensé comme un support d’animation et de sensibilisation. Il ne constitue pas un outil médical ou thérapeutique et ne remplace jamais l’intervention d’un professionnel de santé lorsque celle-ci est nécessaire.',
  },
  {
    question: 'Que faire si une participante est très émue ?',
    answer:
      'Le guide et le bonus consacré au soutien émotionnel proposent des repères simples pour accueillir ce type de moment avec respect et bienveillance. Ils ne remplacent cependant pas l’intervention d’un professionnel qualifié lorsque la situation l’exige.',
  },
  {
    question: 'Peut-on utiliser le kit en entreprise, en association ou dans un établissement ?',
    answer:
      'Oui. Les activités peuvent être adaptées à différents contextes : associations, entreprises, collectivités, groupes, ateliers ou actions de sensibilisation.',
  },
]
